import React from 'react';
import { privacyPolicyContent } from '../data/homeContent';

const accent = "#16bb8b";

const Section = ({ title, children }) => (
  <section className="mb-10 pl-6 border-l-4" style={{ borderColor: accent }}>
    <h2 className="text-2xl font-bold mb-2" style={{ color: accent }}>{title}</h2>
    <div className="text-gray-700">{children}</div>
  </section>
);

const PrivacyPolicy = () => (
  <div className="max-w-4xl mx-auto px-4 py-12 bg-gray-50 min-h-screen">
    <h1 className="text-4xl font-extrabold mb-6" style={{ color: accent }}>
      {privacyPolicyContent.title}
    </h1>
    <p className="text-gray-700 mb-8">{privacyPolicyContent.intro}</p>
    {privacyPolicyContent.sections.map((section, idx) => (
      <Section title={section.title} key={section.title}>
        {/* Paragraph content */}
        {section.content && section.content.map((para, i) => (
          <p className="mb-2" key={i}>{para}</p>
        ))}
        {/* List with label:value (for Information We Collect, Contact Us) */}
        {section.list && Array.isArray(section.list) && typeof section.list[0] === 'object' ? (
          <ul className="list-disc ml-6">
            {section.list.map((item, i) => (
              <li key={i}>
                <span className="font-semibold" style={{ color: accent }}>{item.label}</span> {item.value}
              </li>
            ))}
          </ul>
        ) : null}
        {/* Simple list (for How We Use Your Information, Your Rights) */}
        {section.list && Array.isArray(section.list) && typeof section.list[0] === 'string' ? (
          <ul className="list-disc ml-6">
            {section.list.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        ) : null}
        {/* Footer for Contact Us */}
        {section.footer && (
          <p className="text-gray-500 mt-4 text-sm">
            <span className="font-semibold" style={{ color: accent }}>Effective date:</span> {section.footer}
          </p>
        )}
      </Section>
    ))}
  </div>
);

export default PrivacyPolicy; 